// @flow
import { StyledSpan } from '@src/common-utils/styledComponents';
import React from 'react';
import { useGlobalDiscountProvidedByStatus } from '@src/custom-hooks/useGlobalDiscountProvidedByStatus';

import { SystemAdminNonAdminStatusLabel } from '../../common/SystemAdminNonAdminStatusLabel';

export const GlobalDiscountProvidedByLabelContainer = () => {
  const {
    isGlobalDiscountImported,
    isGlobalDiscountSystemGenerated,
    isGlobalDiscountGivenByAdminUser,
    shouldShowGDTag,
  } = useGlobalDiscountProvidedByStatus();

  return (
    shouldShowGDTag && (
      <StyledSpan
        style={{
          marginLeft: '-12px',
          marginTop: '0.5rem',
          position: 'absolute',
        }}
      >
        <SystemAdminNonAdminStatusLabel
          isAddedByAdmin={isGlobalDiscountGivenByAdminUser}
          isImported={isGlobalDiscountImported}
          isSystemGenerated={isGlobalDiscountSystemGenerated}
        />
      </StyledSpan>
    )
  );
};

// todo::GDCNBCA remove hardcoded styles
